import { ToggleButton, ToggleButtonGroup } from '@sunwebgroup/uds-ui/toggle-button'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { createUserReviewsEvent } from '@/scopes/products/user-reviews/infrastructure/analytics'
import { getPartyCompositionType } from '../utils'
import styles from './PartyCompositionFilter.module.css'

interface PartyCompositionFilterProps {
  setReviewsAmount?: (amount: number | null) => void
}

export function PartyCompositionFilter({ setReviewsAmount }: PartyCompositionFilterProps) {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()

  const { partyCompositionGroups, partyCompositionGroupId, setPartyCompositionGroupId } = useUserReviews()

  const handleClickPartyCompositionGroup = (groupId: string) => {
    setPartyCompositionGroupId(groupId)
    sendEvent(
      createUserReviewsEvent({
        description: 'show reviews of party composition',
        element: 'Chip',
        result: intl.formatMessage({ id: `reviews_party_composition_${getPartyCompositionType(groupId)}_label` }),
      }),
    )
  }

  useEffect(() => {
    if (!setReviewsAmount)
      return

    if (partyCompositionGroupId === 'all') {
      const reviewsAmount = partyCompositionGroups.reduce((result, group) => result + group.amount, 0)
      setReviewsAmount(reviewsAmount)
    }
    else {
      const selectedGroup = partyCompositionGroups.find(group => group.groupId === partyCompositionGroupId)

      if (selectedGroup) {
        setReviewsAmount(selectedGroup.amount)
      }
    }
  }, [partyCompositionGroupId, partyCompositionGroups, setReviewsAmount])

  return (
    <ToggleButtonGroup className={styles.toggleButtonGroup} type="single" onValueChange={handleClickPartyCompositionGroup} value={partyCompositionGroupId}>
      <ToggleButton
        value="all"
        title={intl.formatMessage({ id: 'reviews_party_composition_all_label' })}
        size="M"
      />
      {partyCompositionGroups?.map(group => (
        <ToggleButton
          key={group.groupId}
          value={group.groupId}
          title={intl.formatMessage({ id: `reviews_party_composition_${getPartyCompositionType(group.groupId)}_label` })}
          size="M"
        />

      ))}
    </ToggleButtonGroup>
  )
}
